import {
  IconBottle,
  IconBuildingStore,
  IconPackage,
  IconTable,
  IconUsersGroup,
  type IconProps,
} from "@tabler/icons-react"
import type { ComponentType } from "react"
import type { EntityGroupType } from "../../api/ingestionApi"

export type EntityIconComponent = ComponentType<IconProps>

export const ENTITY_ICONS: Record<EntityGroupType, EntityIconComponent> = {
  suppliers: IconBuildingStore,
  articles: IconTable,
  substances: IconBottle,
  products: IconPackage,
  customers: IconUsersGroup,
}
